import Vue from 'vue';
import Router from 'vue-router';
/* AUTH */
import Index from './pages/auth/Index.vue';
import Login from './pages/auth/login/Login.vue';
import LoginExternal from './pages/auth/loginExternal/LoginExternal.vue';
import Register from './pages/auth/register/Register.vue';
import RemindPassword from './pages/auth/remindPassword/RemindPassword.vue';
import ConfirmProfile from './pages/auth/confirmProfile/ConfirmProfile.vue';
/* PRIZES */
import Orders from './pages/prizes/orders/Orders.vue';
import Prizes from './pages/prizes/prizes/Prizes.vue';
import EpsCard from './pages/prizes/epsCard/EpsCard.vue';
import EpsCart from './pages/prizes/epsCart/EpsCart.vue';
/* PROFILE */
import Dashboard from './pages/profile/dashboard/Dashboard.vue';
import ProfilePassport from './pages/profile/profilePassport/ProfilePassport.vue';
import ProfileEdit from './pages/profile/profileEdit/ProfileEdit.vue';
import ProfilePurse from './pages/profile/profilePurse/ProfilePurse.vue';
/* COURSES */
import Courses from './pages/courses/courses/Courses.vue';
import Course from './pages/courses/course/Course.vue';
import Test from './pages/courses/test/Test.vue';
import Results from './pages/courses/result/Results.vue';
/* SALES */
import Sales from './pages/sales/sales/Sales.vue';
import AddSale from './pages/sales/addSale/AddSale.vue';
/* NEWS & INSTRUCTIONS */
import News from './pages/news/news/News.vue';
import Publication from './pages/news/publication/Publication.vue';
import Instructions from './pages/news/instructions/Instructions.vue';
import Instruction from './pages/news/instruction/Instruction.vue';
/* TICKETS */
import Tickets from './pages/tickets/tickets/Tickets.vue';
/* NOTIFICATIONS */
import MobileNotifications from './pages/mobileNotifications/MobileNotifications.vue';
/* COMMON */
import Feedback from './pages/feedback/Feedback.vue';
import NotFound from './pages/NotFound.vue';
import Reset from './pages/Reset.vue';
import programClosed from './programClosed';

Vue.use(Router);

const routes = [
  { path: '/program-closed', component: Index },
  { path: '/', component: Index, meta: { requiresGuest: true } },
  { path: '/login', component: Login, meta: { requiresGuest: true } },
  { path: '/login-external/:id/:token', component: LoginExternal, props: true, meta: { requiresGuest: true } },
  { path: '/register', component: Register, meta: { requiresGuest: true } },
  { path: '/remind', component: RemindPassword, meta: { requiresGuest: true } },
  { path: '/confirm-profile', component: ConfirmProfile, meta: { requiresGuest: true } },
  { path: '/orders', component: Orders, meta: { requiresAuth: true } },
  { path: '/prizes', component: Prizes, meta: { requiresAuth: true } },
  { path: '/eps/:type', component: EpsCard, props: true, meta: { requiresAuth: true } },
  { path: '/eps-cart', component: EpsCart, meta: { requiresAuth: true } },
  { path: '/dashboard', component: Dashboard, meta: { requiresAuth: true } },
  { path: '/passport', component: ProfilePassport, meta: { requiresAuth: true } },
  { path: '/profile', component: ProfileEdit, meta: { requiresAuth: true } },
  { path: '/purse', component: ProfilePurse, meta: { requiresAuth: true } },
  { path: '/courses', component: Courses, meta: { requiresAuth: true } },
  { path: '/courses/:id', component: Course, props: true, meta: { requiresAuth: true } },
  { path: '/test/:id', component: Test, props: true, meta: { requiresAuth: true } },
  { path: '/results/:id', component: Results, props: true, meta: { requiresAuth: true } },
  { path: '/sales', component: Sales, meta: { requiresAuth: true } },
  { path: '/sale/:id', component: AddSale, props: true, meta: { requiresAuth: true } },
  { path: '/news', component: News, meta: { requiresAuth: true } },
  { path: '/publication/:id', component: Publication, props: true, meta: { requiresAuth: true } },
  { path: '/instructions', component: Instructions, meta: { requiresAuth: true } },
  { path: '/instruction/:id', component: Instruction, props: true, meta: { requiresAuth: true } },
  { path: '/notifications', component: MobileNotifications, meta: { requiresAuth: true } },
  { path: '/tickets/', component: Tickets, meta: { requiresAuth: true } },
  { path: '/reset', component: Reset },
  { path: '/feedback', component: Feedback },
  { path: '*', component: NotFound },
];

const router = new Router({
  mode: 'history',
  routes,
});

router.beforeEach((to, from, next) => {
  if (programClosed) {
    if (to.path === '/program-closed') {
      next();
    } else {
      next('/program-closed');
    }
    return;
  }

  if (to.path === '/program-closed') {
    next('/');
    return;
  }

  Vue.notify({ group: 'error', clean: true });
  const { requiresGuest, requiresAuth } = to.meta;
  let isAuthenticated = false;
  const storage = localStorage.getItem('promo');

  if (storage !== null) {
    const { token } = JSON.parse(storage);
    if (token !== undefined && token !== null) {
      isAuthenticated = true;
    }
  }

  if (requiresGuest && isAuthenticated) {
    next('/dashboard');
    return;
  }

  if (requiresAuth && !isAuthenticated) {
    next('/login');
    return;
  }

  next();
});

export default router;
